{
  "social": [
    {
      "key": "instagram",
      "name": "Instagram",
      "url": "https://www.instagram.com/toby.site/"
    },
    {
      "key": "tiktok",
      "name": "TikTok",
      "url": "https://www.tiktok.com/@toby.site"
    },
    { "key": "x", "name": "X", "url": "https://x.com/TOBYsitecom" },
    {
      "key": "linkedin",
      "name": "LinkedIn",
      "url": "https://www.linkedin.com/company/tobysite"
    },
    {
      "key": "youtube",
      "name": "YouTube",
      "url": "https://www.youtube.com/@TOBYsite"
    }
  ],
  "play_store": "https://play.google.com/store/apps/details?id=site.toby.app",
  "app_store": null,
  "google_review": "https://search.google.com/local/writereview?placeid=ChIJz8RgvimNg0YRPj6Zjto96Ww"
}
